import * as React from 'react'
import ContextMenuIcon from '../icons/ui/ContextMenu'

class ContextMenu extends React.Component<any, any> {
  constructor(props: any) {
    super(props)

    this.state = {
      visible: false
    }
  }

  public render() {
    const modalStyles: any = {
      display: this.state.visible ? 'block' : 'none',
      width: '160px',
      right: '12px',
      top: '10px'
    }

    return (
      <div
        className='ContextMenu flex justify-center cursor--pointer relative'
        style={{ width: '28px', height: '17px' }}
        onMouseEnter={this.mouseEnter}
        onMouseLeave={this.mouseLeave}
      >
        <ContextMenuIcon className='svg-fill-grey float-right icon--3x16' />
        <div className='MenuModal z2 p1 bg-white shadow absolute' style={modalStyles}>
          {this.props.children}
        </div>
      </div>
    )
  }

  public mouseEnter = (e: React.MouseEvent<HTMLElement>) => {
    this.setState({ visible: true })
  }

  public mouseLeave = (e: React.MouseEvent<HTMLElement>) => {
    this.setState({ visible: false })
  }
}

export default ContextMenu



// WEBPACK FOOTER //
// ./src/components/ui/ContextMenu.tsx